var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.57715 8.95311V30.2416C5.57715 30.5858 5.71391 30.916 5.95735 31.1594C6.20078 31.4029 6.53095 31.5396 6.87523 31.5396H32.3175C32.6618 31.5396 32.992 31.4029 33.2354 31.1594C33.4788 30.916 33.6156 30.5858 33.6156 30.2416V8.95311C33.6156 8.60883 33.4788 8.27866 33.2354 8.03523C32.992 7.79179 32.6618 7.65503 32.3175 7.65503H6.87523C6.53095 7.65503 6.20078 7.79179 5.95735 8.03523C5.71391 8.27866 5.57715 8.60883 5.57715 8.95311ZM24.6031 11.6356C25.1928 11.6392 25.7682 11.8173 26.2568 12.1476C26.7454 12.4778 27.1252 12.9453 27.3484 13.4912C27.5716 14.037 27.6281 14.6367 27.5109 15.2147C27.3936 15.7926 27.1078 16.3229 26.6896 16.7386C26.2713 17.1543 25.7393 17.4369 25.1607 17.5506C24.582 17.6644 23.9827 17.6042 23.4382 17.3777C22.8937 17.1512 22.4285 16.7685 22.1012 16.278C21.774 15.7874 21.5993 15.2109 21.5993 14.6212C21.6026 13.8272 21.9207 13.0669 22.4838 12.5072C23.0469 11.9475 23.8091 11.634 24.6031 11.6356ZM7.63655 29.549V23.352L15.6041 16.1996L21.6908 22.2584L14.3567 29.549H7.63655ZM31.5387 29.549H17.1949L26.5787 20.2029L31.5387 24.4385V29.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.68284 2.46313C1.33857 2.46313 1.0084 2.5999 0.764964 2.84333C0.521527 3.08677 0.384766 3.41694 0.384766 3.76121L0.384766 26.0881C0.384766 26.4324 0.521527 26.7626 0.764964 27.006C1.0084 27.2495 1.33857 27.3862 1.68284 27.3862H3.50015V6.8766C3.50015 6.53233 3.63691 6.20215 3.88035 5.95872C4.12378 5.71528 4.45396 5.57852 4.79823 5.57852H29.4617V3.76121C29.4617 3.41694 29.3249 3.08677 29.0815 2.84333C28.8381 2.5999 28.5079 2.46313 28.1636 2.46313H1.68284Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.2308,
    height: 33.2308,
    fill: "white",
    transform: "translate(0.384766 0.384766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharp);
export default __webpack_public_path__ + "static/media/sharp.c1a01fe2a4cfe10933f79f40184dd15a.svg";
export { ForwardRef as ReactComponent };